import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';
import { videoLazyLoading } from './components/video.js';

document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('testimonials', '.testimonials-container');
  slickSliderGenerator('features', '.features-container');
  videoLazyLoading();
  getSVG();
});
